import { render, staticRenderFns } from "./ChapterDetailModal.vue?vue&type=template&id=29e5c97a&"
import script from "./ChapterDetailModal.vue?vue&type=script&lang=js&"
export * from "./ChapterDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports